import React from "react";
import { Route, Routes, useNavigate } from "react-router-dom";
import Admin from "../../TutorDashboard/Pages/admin";
import Resources from "../components/Resources";
import ExamArena from "../components/ExamArena/pages/ExamArena";
// import Interviews from "../components/ExamArena/pages/";

//import Admin from "./components/TutorDashboard/Pages/admin"
const Dashboard = () => {
  // console.log("<<<<<<<<<<========= hit ======>>>>>>>>>>");
  return (
    <div>
      <Routes>
        <Route path="resources" element={<Resources />} />
        <Route path="exam_arena" element={<ExamArena />} />
        <Route path="" element={<Admin />} />
        {/* <Route path="interviews" element={<Admin />} /> */}
      </Routes>
    </div>
  );
};

export default Dashboard;
